import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function MedicalDisclaimers() {
    return (
        <div className="relative min-h-screen bg-[#050510] text-gray-300 py-24 px-6 md:px-12 font-sans font-medium">
            <div className="max-w-3xl mx-auto relative z-10">
                <Link to="/" className="inline-flex items-center gap-2 text-gray-400 hover:text-white mb-12 transition-colors">
                    <ArrowLeft className="w-4 h-4" />
                    Back to Home
                </Link>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <div className="flex items-center gap-4 mb-8">
                        <div className="w-12 h-12 bg-red-500/10 border border-red-500/20 rounded-xl flex items-center justify-center">
                            <AlertTriangle className="w-6 h-6 text-red-500" />
                        </div>
                        <h1 className="text-4xl font-bold tracking-tight text-white">Medical Disclaimer</h1>
                    </div>

                    <div className="prose prose-invert max-w-none space-y-6">
                        <p className="text-lg leading-relaxed text-gray-400">
                            Last Updated: October 2023
                        </p>

                        <div className="bg-white/5 border border-white/10 p-6 rounded-2xl mb-8">
                            <h2 className="text-xl font-bold text-white mb-3">1. Intended Use and Purpose</h2>
                            <p className="leading-relaxed">
                                Curezy AI ("The Platform") is an artificial intelligence-based tool designed to assist healthcare professionals by functioning as a "second opinion" engine. It analyzes symptoms and medical imagery to generate a consensus-driven differential diagnosis.
                                <strong className="text-white block mt-2">Curezy AI is NOT a substitute for professional medical advice, diagnosis, or treatment.</strong>
                            </p>
                        </div>

                        <div className="bg-white/5 border border-white/10 p-6 rounded-2xl mb-8">
                            <h2 className="text-xl font-bold text-white mb-3">2. No Patient-Physician Relationship</h2>
                            <p className="leading-relaxed">
                                Use of this software does not establish a doctor-patient relationship. The outputs generated by the AI Council are for informational and educational purposes only. Patients interacting directly with the voice agent or symptom checker must always consult a licensed doctor before making any healthcare decisions.
                            </p>
                        </div>

                        <div className="bg-white/5 border border-white/10 p-6 rounded-2xl mb-8">
                            <h2 className="text-xl font-bold text-white mb-3">3. Beta Limitation Status</h2>
                            <p className="leading-relaxed">
                                The X-Ray Analysis and EHR Syncing features are currently in Beta. Machine learning models, while highly advanced, are known to occasionally "hallucinate" or misinterpret edge cases. Physicians must universally verify the model's output against their own clinical judgment.
                            </p>
                        </div>

                        <div className="bg-white/5 border border-white/10 p-6 rounded-2xl mb-8">
                            <h2 className="text-xl font-bold text-white mb-3">4. Emergency Situations</h2>
                            <p className="leading-relaxed text-red-400">
                                If you think you may have a medical emergency, call your local emergency services (e.g., 911) or go to the nearest hospital immediately. Do not rely on Curezy AI for urgent healthcare needs.
                            </p>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    );
}
